import React, { useEffect, FC } from "react";
import { Table, Button, message } from "antd";
import { YHModal } from "@/components/YHModal";
import { useMaintenanceDetailsModel } from "./maintenanceDetailsModel";
import { ColumnsType } from "antd/lib/table";
import { YhBox } from "@/components/YhBox";
import { RouterParamType } from "@/model/navModel";
import { formatIntPoint } from "@/utils/utils";
import { EditableCell, EditableRow } from "@/components/YHEditTable/editTable";
import { YhBut } from "@/components/YhButton";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { IItemDetailList } from "../../chargebackTypes";
enum OPT_TYPE {
    ADD = 1,
    REMOVE = 2
}
export const AddItemModal: FC<RouterParamType> = ({ id, mode }) => {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const { itemModel: visible, workItemDataSource, addItemDataSource, setSearchWorkItemData, setWorkItemDataSource, transformsToItemDetailList, setAddItemDataSource, setItemModel, workloadItemData, resetWorkloadItemData } = useMaintenanceDetailsModel();

    useEffect(() => {
        if (visible) {
            workloadItemData();
        }
    }, [visible])

    const column = (optype: number) => [
        {
            // title: '序号',
            title: Locale['SN'],
            width: 60,
            fixed: "left",
            render: (t: any, r: any, i: number) => <>{i + 1}</>
        }, {
            // title: '项目编码',
            title: Locale['Item Code'],
            width: 120,
            dataIndex: 'code',
            fixed: "left",
        }, {
            // title: '项目名称',
            title: Locale['Item'],
            width: 150,
            dataIndex: 'name',
            fixed: "left",
        }, {
            // title: '项目名称',
            title: Locale['ItemEn'],
            width: 160,
            dataIndex: 'nameEn',
            fixed: "left",
        }, {
            // title: '原单工时',
            title: Locale['Original man hour'],
            width: 120,
            dataIndex: 'originalNum',
        }, {
            // title: '工时',
            title: Locale['Man-hours'],
            width: 120,
            dataIndex: 'workHours',
            editable: true,
        }, {
            // title: '单价',
            title: Locale['Unit Price'],
            width: 120,
            dataIndex: 'price',
        }, {
            // title: '工时费',
            title: Locale['Labor Cost'],
            width: 120,
            dataIndex: 'amount',
        }, {
            // title: '操作',
            title: Locale['Operation'],
            width: 120,
            fixed: "right",
            render: (text: any, record: any) => optype == OPT_TYPE.ADD ? (
                <YhBut
                    type="add"
                    // txt="添加"
                    txt={Locale['Add']}
                    click={() => add(record)}
                    disabled={!!addItemDataSource.find(item => item.id === record.id)}
                />
            ) : (
                <YhBut
                    type="delete"
                    // txt="删除"
                    txt={Locale['Delete']}
                    click={() => remove(record)}
                />
            )
        }
    ];
    const newSelectColumns = (optType: number) =>
        column(optType).map((col: any, index) => {
            return {
                ...col,
                onCell: (record: IItemDetailList, rowIndex: number) => ({
                    colIndex: index,
                    rowIndex,
                    record,
                    rules: col.rules,
                    options: col.options,
                    editType: col.editType,
                    editable: col?.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: optType == OPT_TYPE.ADD ? notHandleSave : handleSave,
                }),
            }
        })
    const add = async (record: IItemDetailList) => {
        setAddItemDataSource(origin => [...origin, record])
    }
    const remove = async (record: IItemDetailList) => {
        const filterAddDataSource = addItemDataSource.filter(item => item.id != record.id)
        setAddItemDataSource(filterAddDataSource)
    }
    const notHandleSave = (row: IItemDetailList) => {
        let { workHours, price, originalNum } = row;
        workHours = +formatIntPoint(workHours);
        price = +formatIntPoint(price);
        if (workHours > originalNum) {
            workHours = originalNum as number;
            message.warning('修改工时，不能大于原单的工时');
        }
        let newRow = {
            ...row,
            workHours,
            amount: workHours * price
        }
        const index = workItemDataSource.findIndex((item) => row.id === item.id);
        const item = workItemDataSource[index];
        workItemDataSource.splice(index, 1, { ...item, ...newRow });
        setWorkItemDataSource([...workItemDataSource])
    }
    const handleSave = (row: IItemDetailList) => {
        let { workHours, price, originalNum } = row;
        workHours = +formatIntPoint(workHours);
        price = +formatIntPoint(price);
        if (workHours > originalNum) {
            workHours = originalNum as number;
            // message.warning('修改数量时，数量×价格×折扣 不能大于对应配件的明细总计');
            message.warning('修改工时，不能大于原单的工时');
        }
        let newRow = {
            ...row,
            amount: workHours * price
        }
        console.log(newRow)
        const index = addItemDataSource.findIndex((item) => row.id === item.id);
        const item = addItemDataSource[index];
        addItemDataSource.splice(index, 1, { ...item, ...newRow });
        setAddItemDataSource([...addItemDataSource])
    }
    const rightChildren = <div className="flex">
        <Button onClick={() => resetWorkloadItemData()} style={{ margin: "0px 12px 0px 15px" }} shape="round">{Locale['Reset']}</Button>
    </div>
    const onOK = async () => {
        transformsToItemDetailList(mode)
        onCancel()
    }
    const onCancel = () => {
        setItemModel(false);
        setAddItemDataSource([])
        setSearchWorkItemData({})
    };
    return <YHModal
        visible={visible}
        onOk={onOK}
        onCancel={onCancel}
        // title="选择项目"
        title={Locale["Select Items"]}
        width={1000}
        bodyHeight={700}
        showFooter={true}
    >
        <YhBox title={Locale["List of items to be selected"]} rightChildren={rightChildren} style={{ marginBottom: "15px" }}>
            <Table
                // size="small"
                rowKey={record => record.id as string}
                rowClassName='editable-row yh-edit-table-tr'
                columns={newSelectColumns(OPT_TYPE.ADD) as ColumnsType<IItemDetailList>}
                dataSource={workItemDataSource}
                pagination={false}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                onRow={record => ({
                    onClick: () => { }
                })}
                scroll={{ x: 'max-content', y: 200 }}
            />
        </YhBox>
        <YhBox title={Locale["List of selected items"]}>
            <Table
                rowKey={record => record.id as string}
                rowClassName='editable-row yh-edit-table-tr'
                columns={newSelectColumns(OPT_TYPE.REMOVE) as ColumnsType<IItemDetailList>}
                dataSource={addItemDataSource}
                pagination={false}
                onRow={record => ({
                    onClick: () => { }
                })}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                scroll={{ x: 'max-content', y: 200 }}
            />
        </YhBox>
    </YHModal>
}